import { render, staticRenderFns } from "./CardSupplierForm.vue?vue&type=template&id=16fa26fc&scoped=true"
import script from "./CardSupplierForm.vue?vue&type=script&lang=js"
export * from "./CardSupplierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa26fc",
  null
  
)

export default component.exports